/**
 * WalletBillingHistory Component
 *
 * Main billing history card that displays plan charges and wallet history tabs.
 * Uses ResolveCapability to determine wallet feature availability.
 */
import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import Card from "../../../../components/layouts/card/card";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import "./wallet-billing-history.scss";
import planChargesBillingTableStore from "../../stores/plan-charges-billing-store";
import currentAccountStore from "../../../accounts/stores/current-account-store";
import currentPortalStore from "../../../../stores/current-portal-store";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";
import WalletBillingHistoryTabs from "./wallet-billing-history-tabs";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import IconDownload from "../../../../components/icons/icon-download/icon-download";
import SbrReceiptModal from "../sbr-receipt-modal/sbr-receipt-modal";
import lastSbrReceiptStore from "../../stores/last-sbr-receipt-store";

interface IWalletBillingHistoryProps {}

const WalletBillingHistory: React.FC<IWalletBillingHistoryProps> = observer(() => {
    const buttonContainerRef = useRef<HTMLDivElement | null>(null);
    const [isSbrReceiptModalOpen, setIsSbrReceiptModalOpen] = useState(false);

    useEffect(() => {
        planChargesBillingTableStore.loadPage(1);
        currentAccountStore.load();
        currentPortalStore.load();
        lastSbrReceiptStore.load();
    }, []);

    return (
        <Card>
            <div className="wallet-billing-history">
                <div className="heading">
                    <FontHeading2 variant={FONT_VARIANT.BOLD}>Billing History</FontHeading2>
                    <div ref={buttonContainerRef} className="billing-history-heading-buttons">
                        <Button
                            leftIcon={IconDownload}
                            text={'Ship by ReturnGO receipt'}
                            variant={BUTTON_VARIANTS.Secondary}
                            onClick={() => setIsSbrReceiptModalOpen(true)}
                        />
                    </div>
                </div>
                <ResolveCapability capability={PROFILE_CAPABILITIES.WALLET}>
                    {({ isSupported }) => (
                        <WalletBillingHistoryTabs
                            isSupported={isSupported}
                            buttonContainerRef={buttonContainerRef}
                        />
                    )}
                </ResolveCapability>
            </div>
            {isSbrReceiptModalOpen && (
                <SbrReceiptModal onClose={() => setIsSbrReceiptModalOpen(false)} />
            )}
        </Card>
    );
});

export default WalletBillingHistory;
